module.exports = __webpack_public_path__ + "img/ico_tramitesDigitales.a319a0ef.png";